// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth, initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider } from 'firebase/app-check';
import { FirebaseAppCheck } from '@capacitor-firebase/app-check';
import { isNative } from './native';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBGmRG_Q2C1YUl8hkDlW0FDYR-KDlggWAM",
  authDomain: "medxmeet.firebaseapp.com",
  projectId: "medxmeet",
  storageBucket: "medxmeet.firebasestorage.app",
  messagingSenderId: "633607845163",
  appId: "1:633607845163:web:949d13bb87b8d2703ac16e",
  measurementId: "G-4T71YFKLJG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check — verifies requests actually come from this app.
// The iPhone app also runs on "localhost", so the web debug token is web-only.
if (!isNative && window.location.hostname === 'localhost') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

// In the iPhone app reCAPTCHA can't run; the native SDK gets tokens instead.
// AppDelegate.swift picks the provider: debug in Xcode debug builds (token printed
// to the Xcode console), App Attest in release builds.
const nativeAppCheckToken = async () => {
  const { token, expireTimeMillis } = await FirebaseAppCheck.getToken();
  return { token, expireTimeMillis };
};

try {
  initializeAppCheck(app, {
    provider: isNative
      ? new CustomProvider({ getToken: nativeAppCheckToken })
      : new ReCaptchaV3Provider('6LeIEZstAAAAAJSlr1le2HqFfec1mOckUt3m6154'),
    isTokenAutoRefreshEnabled: true
  });
} catch (e) {
  console.warn('App Check init skipped:', e);
}

// Initialize services. Inside the app's WebView, Auth needs its persistence set
// explicitly (and no popup/redirect resolver) so users stay signed in.
export const auth = isNative
  ? initializeAuth(app, { persistence: [indexedDBLocalPersistence, browserLocalPersistence] })
  : getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');
export default app;
